module.exports = __webpack_public_path__ + "brandon_med-webfont.561c615e7b7db1082a35.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_med-webfont.woff
// module id = 943
// module chunks = 7